export { default as createConnector } from './src/core/createConnector';



// WEBPACK FOOTER //
// ./index.js